import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as authActions from "../../store/actions/authActions";

// Stylesheet
import "./Profile.css";

// Assets
import profilePage from "../../assets/defaultProfile.jpg";

// Material UI Icons
import ShareIcon from "@mui/icons-material/Share";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";

// Pages and Elements
import NFTCards from "../../components/nftCards/NFTCards";
import EditProfile from "./editProfile/EditProfile";
import Copy from "../../components/copyToClipboard/Copy";
import PreloaderInner from "./../../components/preloader/loader";

// AWS connectivity
import Web3 from "web3";
import firebase from "./../../firebase";
import { useSelector } from "react-redux";
import { authFeatureKey } from "../../store/featureKeys";
import { Menu, MenuItem } from "@szhsin/react-menu";
import copy from "copy-to-clipboard";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
} from "react-share";
import toast from "react-hot-toast";

function Profile() {
  let location = window.location.href;
  const { openConnectModal, isConnected, currentUser, loading, user } =
    useSelector((state) => {
      return state[authFeatureKey];
    });
  let shareUrl = `${location}/${user.username}`;

  const [account, setAccount] = React.useState("");
  const [loader, setLoader] = React.useState(true);
  const [userName, setUserName] = React.useState("");
  const [name, setName] = React.useState("");
  const [userImageURL, setUserImageURL] = React.useState("");
  const [walletAddress, setWalletAddress] = React.useState("");
  const [isUpdated, setUpdated] = React.useState(false);
  const [nfts, setNFts] = React.useState([]);
  const [ownedNfts, setOwnedNfts] = React.useState([]);
  const [hasNFT, setHasNFT] = React.useState(false);
  //const a;
  React.useEffect(async () => {
    const { ethereum } = window;

    const web3 = new Web3(ethereum);
    const a = await web3.eth.getAccounts();
    if (a != account) {
      setAccount(a);
    }
    fetchData();
  }, [account]);

  React.useEffect(() => {
    if (isUpdated) {
      fetchData();
      setTimeout(() => {
        setUpdated(false);
      }, 2000);
    }
  }, [isUpdated]);

  const fetchData = async () => {
    if (isConnected) {
      await firebase
        .firestore()
        .collection("UserDataModel")
        .limit(1)
        .where("walletAddress", "==", `${currentUser}`)
        .get()
        .then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            const userDetail = doc.data();
            setUserName(userDetail.username);
            setName(userDetail.name);
            setUserImageURL(userDetail.imageURL);
            setTimeout(() => {
              setLoader(false);
            }, 2000);
          });
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    }
  };

  const fetchNFTs = () => {
    firebase
      .firestore()
      .collection("NFTDataModel")
      .limit(10)
      .where("creatorAddress", "==", `${currentUser}`)
      .get()
      .then((snapshot) => {
        setNFts([]);
        snapshot.forEach((doc) => {
          let document = doc.data();
          document.docID = doc.id;
          if (userName && userImageURL) {
            document.userImageURL = userImageURL;
            document.username = userName;
            setNFts((prev) => [...prev, document]);
          } else {
            firebase
              .firestore()
              .collection("UserDataModel")
              .limit(1)
              .where("walletAddress", "==", `${document.creatorAddress}`)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((docuser) => {
                  console.log(docuser);
                  const userDetail = docuser.data();
                  document.userImageURL = userDetail.imageURL;
                  document.username = userDetail.username;
                  setNFts((prev) => [...prev, document]);
                  setName(userDetail.name);
                  setUserImageURL(userDetail.imageURL);
                  setWalletAddress(userDetail.walletAddress);
                  console.log(nfts);
                });
              });
          }
        });
      });
  };
  const fetchOwnedNFTs = () => {
    firebase
      .firestore()
      .collection("NFTDataModel")
      .limit(10)
      .where("ownerAddress", "==", `${currentUser}`)
      .get()
      .then((snapshot) => {
        setOwnedNfts([]);
        snapshot.forEach((doc) => {
          let document = doc.data();
          document.docID = doc.id;
          if (userName && userImageURL) {
            document.userImageURL = userImageURL;
            document.username = userName;
            setOwnedNfts((prev) => [...prev, document]);
          } else {
            firebase
              .firestore()
              .collection("UserDataModel")
              .limit(1)
              .where("walletAddress", "==", `${document.creatorAddress}`)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((docuser) => {
                  const userDetail = docuser.data();
                  document.userImageURL = userDetail.imageURL;
                  document.username = userDetail.username;
                  setOwnedNfts((prev) => [...prev, document]);
                  setName(userDetail.name);
                  setUserImageURL(userDetail.imageURL);
                  setWalletAddress(userDetail.walletAddress);
                });
              });
          }
        });
      });
  };

  React.useEffect(() => {
    if (currentUser && !hasNFT) {
      setHasNFT(true);
      fetchNFTs();
      fetchOwnedNFTs();
    }
  }, [currentUser, hasNFT]);
  const menus = ["left"];
  const [display, setDisplay] = useState("arrow");
  const [align, setAlign] = useState("center");
  const [position, setPosition] = useState("anchor");
  const [viewScroll, setViewScroll] = useState("auto");
  return (
    <section>
      {loading && <PreloaderInner />}
      <div className="share-buttons">
        {menus.map((direction) => (
          <Menu
            menuButton={
              <button>
                <ShareIcon />
                <p>Share</p>
              </button>
            }
            key={direction}
            direction={direction}
            align={align}
            position={position}
            viewScroll={viewScroll}
            arrow={display === "arrow"}
            offsetX={
              display === "offset" &&
              (direction === "left" || direction === "right")
                ? 12
                : 0
            }
            offsetY={
              display === "offset" &&
              (direction === "top" || direction === "bottom")
                ? 12
                : 0
            }
          >
            <MenuItem
              onClick={(e) => {
                copy(shareUrl);
                toast.success("Link Copied Successfully");
              }}
            >
              <div className="option-container">
                <div className="icon-box">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="size-of-icon"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M7 9a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H9a2 2 0 01-2-2V9z" />
                    <path d="M5 3a2 2 0 00-2 2v6a2 2 0 002 2V5h8a2 2 0 00-2-2H5z" />
                  </svg>
                </div>
                <div className="option-text">Copy Link</div>
              </div>
            </MenuItem>
            <MenuItem>
              <FacebookShareButton url={shareUrl} title={user.username}>
                <div className="option-container">
                  <div className="icon-box">
                    <FacebookIcon size={"1.5rem"} />
                  </div>
                  <div className="option-text">Share on Facebook</div>
                </div>
              </FacebookShareButton>
            </MenuItem>
            <MenuItem>
              <TwitterShareButton url={shareUrl} title={user.username}>
                <div className="option-container">
                  <div className="icon-box">
                    <TwitterIcon size={"1.5rem"} />
                  </div>
                  <div className="option-text">Share on Twitter</div>
                </div>
              </TwitterShareButton>
            </MenuItem>
          </Menu>
        ))}
        <EditProfile setUpdated={setUpdated} account={currentUser} />
      </div>
      <div className="profile">
        <img src={user.imageURL ? user.imageURL : profilePage} alt="profile" />
        <h2 className="yellow">{user.name}</h2>
        <p>@{user.username}</p>

        <Copy url={currentUser} />
        <div className="social-icons">
          {user.twitter ? (
            <a href="https://twitter.com/LoopGem">
              <TwitterIcon />
            </a>
          ) : null}
          {user.instagram ? (
            <a href="https://www.instagram.com/loop_gem/">
              <InstagramIcon />
            </a>
          ) : null}
          {user.youtube ? (
            <a href="https://www.facebook.com/loopgem/">
              <YouTubeIcon />
            </a>
          ) : null}
        </div>
      </div>
      <br />
      <br />

      <h1 className="space-heading margin-heading">NFTs CREATED</h1>
      <NFTCards nfts={nfts} />
      <h1 className="space-heading margin-heading">NFTs OWNED</h1>
      <NFTCards nfts={ownedNfts} />
    </section>
  );
}

export default Profile;
